/* Rokid HK — rokid-campaign.js (safe: guards missing elements) */

/* ============ i18n ============ */
const root = document.documentElement;
const langSel = document.getElementById('langSel');
const langBtn = document.getElementById('langBtn');
function setLang(l){
  root.dataset.lang = l;
  root.lang = l === 'zh' ? 'zh-Hant-HK' : 'en';
  document.querySelectorAll('[data-zh]').forEach(el => { el.textContent = l==='zh' ? el.dataset.zh : el.dataset.en; });
  document.querySelectorAll('[data-zh-ph]').forEach(el => { el.placeholder = l==='zh' ? el.dataset.zhPh : el.dataset.enPh; });
  const lc = document.getElementById('langCur');
  if (lc) lc.textContent = l === 'zh' ? '繁' : 'EN';
  document.querySelectorAll('.lang-menu button').forEach(b => b.classList.toggle('on', b.dataset.lang === l));
  try{ localStorage.setItem('rokid-hk-lang', l); }catch(e){}
  renderDay(currentDay);
}
if (langSel && langBtn){
  langBtn.addEventListener('click', e => {
    e.stopPropagation();
    const open = langSel.classList.toggle('open');
    langBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
  langSel.querySelectorAll('.lang-menu button').forEach(b => b.addEventListener('click', e => {
    e.stopPropagation();
    setLang(b.dataset.lang);
    langSel.classList.remove('open');
    langBtn.setAttribute('aria-expanded', 'false');
  }));
  document.addEventListener('click', () => { langSel.classList.remove('open'); langBtn.setAttribute('aria-expanded', 'false'); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape'){ langSel.classList.remove('open'); langBtn.setAttribute('aria-expanded', 'false'); } });
}

/* ============ clocks & countdown ============ */
const OPEN_AT  = new Date('2026-09-30T10:00:00+08:00');
const PRESALE_AT = new Date('2026-09-01T10:00:00+08:00');
const pad = n => String(n).padStart(2,'0');
const cdGroups = {};
document.querySelectorAll('.flap-g').forEach(el => {
  (cdGroups[el.dataset.u] = cdGroups[el.dataset.u] || []).push(el);
});
function setFlap(els, str){
  if (!els) return;
  els.forEach(el => {
    if (!el.children.length) el.textContent = '';
    for (let i = 0; i < str.length; i++){
      let b = el.children[i];
      if (!b){ b = document.createElement('b'); el.appendChild(b); }
      if (b.textContent !== str[i]){
        b.textContent = str[i];
        b.classList.remove('tick');
        void b.offsetWidth;
        b.classList.add('tick');
      }
    }
  });
}
function tick(){
  const now = new Date();
  // HKT clock
  const hkt = new Date(now.getTime() + (now.getTimezoneOffset() + 480) * 60000);
  const __clock = document.getElementById('hkt-clock');
  if (__clock) __clock.textContent = `${pad(hkt.getHours())}:${pad(hkt.getMinutes())}:${pad(hkt.getSeconds())} HKT`;
  // countdown
  let diff = Math.max(0, OPEN_AT - now);
  const d = Math.floor(diff / 864e5);
  diff -= d * 864e5;
  const h = Math.floor(diff / 36e5); diff -= h * 36e5;
  const m = Math.floor(diff / 6e4); diff -= m * 6e4;
  const s = Math.floor(diff / 1e3);
  const groups = {};
  document.querySelectorAll('.flap-g').forEach(el => { (groups[el.dataset.u] = groups[el.dataset.u] || []).push(el); });
  setFlap(groups.d, String(d).padStart(3,'0'));
  setFlap(groups.h, pad(h));
  setFlap(groups.m, pad(m));
  setFlap(groups.s, pad(s));
}
setInterval(tick, 1000); tick();

/* ============ phase-aware CTA ============ */
const phase = Date.now() < +PRESALE_AT ? 'pre' : (Date.now() < +OPEN_AT ? 'presale' : 'open');
const ctaMap = {
  pre:     { zh:'登記開幕優先入場',           en:'Register — Opening Priority', href:'#register' },
  presale: { zh:'立即預訂 · HK$4,688',        en:'Preorder Now · HK$4,688', href:'#founder'  },
  open:    { zh:'預約取貨時段',               en:'Book a Pickup Slot',      href:'#store'    },
};
(function applyPhase(){
  const c = ctaMap[phase];
  const btn = document.getElementById('cta-primary');
  btn.setAttribute('data-zh', c.zh); btn.setAttribute('data-en', c.en);
  btn.href = c.href;
  const kick = document.getElementById('hero-kicker');
  if (phase === 'presale') kick.setAttribute('data-zh','Founder 1000 預售進行中 · 9月30日開幕');
  if (phase === 'open')    kick.setAttribute('data-zh','旗艦店已開幕 · 每日 10:00–22:00');
  const fb = document.getElementById('cta-founder');
  if (phase !== 'pre'){
    fb.querySelector('[data-zh]').setAttribute('data-zh', phase==='presale' ? '立即預訂 Founder 1000' : '預約取貨時段');
    fb.querySelector('[data-zh]').setAttribute('data-en', phase==='presale' ? 'Preorder Founder 1000' : 'Book Pickup Slot');
  }
  const lbl = document.getElementById('seats-label');
  if (lbl && phase !== 'pre'){ lbl.setAttribute('data-zh','已預訂席位'); lbl.setAttribute('data-en','SEATS RESERVED'); }
})();

/* ============ founder seats (placeholder until Shopify metafield) ============ */
const SEAT_SEGMENTS = 60;
const seatsBar = document.getElementById('seats-bar');
if (seatsBar) for (let i=0;i<SEAT_SEGMENTS;i++) seatsBar.appendChild(document.createElement('i'));
const daysSince = Math.max(0, (Date.now() - +new Date('2026-08-08T00:00:00+08:00')) / 864e5);
const seats = Math.min(1000, Math.round(61 + daysSince * 17));
const filled = Math.round(seats / 1000 * SEAT_SEGMENTS);
[...(seatsBar ? seatsBar.children : [])].forEach((el,i)=>{ if(i<filled) el.classList.add('f'); });
const __sc = document.getElementById('seats-count');
if (__sc) __sc.textContent = seats.toLocaleString();
const __si = document.getElementById('seats-inline');
if (__si) __si.textContent = seats.toLocaleString() + ' / 1,000';

/* ============ verbs accordion ============ */
document.querySelectorAll('.verb').forEach(v => {
  v.querySelector('.verb-row').addEventListener('click', () => {
    const open = v.classList.contains('open');
    document.querySelectorAll('.verb.open').forEach(o=>o.classList.remove('open'));
    if(!open) v.classList.add('open');
  });
});

/* ============ 10-day program ============ */
const DAYS = [
  { d:'10.01', wk:['四','THU'], no:'01', theme:['Cantonese in Sight','粵語日'], aud:['本地 + 內地旅客','Locals + mainland visitors'], cap:['名額 60 · 免費','Capacity 60 · Free'],
    s:[['13:00','粵語入門示範','Cantonese Crash Demo'],['17:00','香港生活實測','HK Daily-life Field Test']] },
  { d:'10.02', wk:['五','FRI'], no:'02', theme:['Travel Hands-Free','旅行日'], aud:['國慶訪港旅客','National Day visitors'], cap:['名額 60 · 免費','Capacity 60 · Free'],
    s:[['13:00','維港路線示範','Victoria Harbour Route Demo'],['17:00','旅行創作者分享','Travel Creator Talk']] },
  { d:'10.03', wk:['六','SAT'], no:'03', theme:['Creator POV Day','第一視角創作日'], aud:['年輕創作者','Young creators'], cap:['名額 50 · 免費','Capacity 50 · Free'],
    s:[['13:00','短視頻工作坊','Short-video Workshop'],['17:00','城市拍攝實戰','City Shooting Field Trip']] },
  { d:'10.04', wk:['日','SUN'], no:'04', theme:['LNB Community Day','共融日'], aud:['家庭 / 社群','Families / community'], cap:['名額 40 · 免費','Capacity 40 · Free'],
    s:[['13:00','字幕與翻譯對談','Subtitles & Translation Talk'],['17:00','安靜體驗時段','Quiet Experience Session']] },
  { d:'10.05', wk:['一','MON'], no:'05', theme:['Digital Culture Day','數字文化日'], aud:['文旅 / 文化機構','Culture & tourism orgs'], cap:['預約制','By reservation'],
    s:[['13:00','香港文化導覽示範','HK Culture Tour Demo'],['17:00','屏幕與藝術講座','Display × Art Lecture']] },
  { d:'10.06', wk:['二','TUE'], no:'06', theme:['Enterprise Service Day','企業日'], aud:['企業客戶 / 投資人','Enterprise / investors'], cap:['預約制','By reservation'],
    s:[['13:00','HR 與培訓專場','HR & Training Session'],['17:00','客戶案例分享','Customer Case Sharing']] },
  { d:'10.07', wk:['三','WED'], no:'07', theme:['Service Without Sales','服務日'], aud:['已購用戶','Existing owners'], cap:['每小時限 12 人','12 per hour'],
    s:[['13:00','免費清潔與設置','Free Cleaning & Setup'],['17:00','上手工作坊','Onboarding Workshop']] },
  { d:'10.08', wk:['四','THU'], no:'08', theme:['Campus & Career Day','校園日'], aud:['本地學生','Local students'], cap:['名額 40 · 免費','Capacity 40 · Free'],
    s:[['13:00','提詞與學習場景','Teleprompter & Study'],['17:00','學生創作者場','Student Creator Session']] },
  { d:'10.09', wk:['五','FRI'], no:'09', theme:['Build With Rokid','開發者日'], aud:['開發者 / 夥伴','Developers / partners'], cap:['預約制','By reservation'],
    s:[['13:00','開發者短講','Developer Talk'],['17:00','企業方案分享','Enterprise Solutions']] },
  { d:'10.10', wk:['六','SAT'], no:'10', theme:['LNB Closing Rally','社群收官'], aud:['社區 / 復訪用戶','Community / returning users'], cap:['名額 60 · 免費','Capacity 60 · Free'],
    s:[['13:00','用戶故事分享','User Stories'],['17:00','UGC 精選 + 下月工作坊日曆發佈','UGC Picks + Next Workshop Calendar']] },
];
let currentDay = 0;
const strip = document.getElementById('dayStrip');
DAYS.forEach((d,i)=>{
  const b = document.createElement('button');
  b.className = 'day-tab' + (i===0?' on':'');
  b.innerHTML = `<div class="dt">${d.d}</div><div class="wk">${d.wk[0]} · ${d.wk[1]}</div>`;
  b.addEventListener('click', ()=>{ currentDay = i; renderDay(i); b.scrollIntoView({behavior:'smooth', inline:'center', block:'nearest'}); });
  strip.appendChild(b);
});
function renderDay(i){
  const zh = root.dataset.lang === 'zh';
  const d = DAYS[i];
  [...strip.children].forEach((el,j)=>el.classList.toggle('on', j===i));
  document.getElementById('dayNo').textContent = `DAY ${d.no} / 10 · ${d.d} ${d.wk[zh?0:1]}`;
  document.getElementById('dayTheme').innerHTML = `${zh?d.theme[0]:d.theme[0]}<span class="zh">${zh?d.theme[1]:d.theme[1]}</span>`;
  document.getElementById('dayAud').textContent = zh ? d.aud[0] : d.aud[1];
  document.getElementById('dayCap').textContent = zh ? d.cap[0] : d.cap[1];
  document.getElementById('daySessions').innerHTML = d.s.map(s=>
    `<div class="session"><span class="tm">${s[0]}</span><span class="ti">${zh?s[1]:s[1]}<span class="en">${s[2]}</span></span></div>`
  ).join('');
}
document.getElementById('dayRegister').addEventListener('click', ()=>{
  const box = document.querySelector('input[name="int"][value="workshop"]');
  if (box) box.checked = true;
  document.getElementById('register').scrollIntoView({behavior:'smooth'});
});

/* ============ register form ============ */
document.getElementById('regForm').addEventListener('submit', e => {
  e.preventDefault();
  const f = e.target;
  if (!f.name.value.trim() || !f.email.value.includes('@') || !/^[0-9]{8,11}$/.test(f.phone.value.trim())){
    f.reportValidity && f.reportValidity();
    return;
  }
  const zh = root.dataset.lang === 'zh';
  const reg = 'HK-' + Math.random().toString(36).slice(2,6).toUpperCase() + '-' + String(Math.floor(Math.random()*900)+100);
  const ints = [...f.querySelectorAll('input[name="int"]:checked')].map(c=>c.value);
  const el = document.getElementById('regSuccess');
  el.innerHTML = (zh
    ? `✓ 登記成功 — 多謝你對 Rokid 香港旗艦店的關注。<br>登記編號 <b>${reg}</b> · 已選項目 ${ints.length||'（未選）'} · 確認通知將發至 ${f.email.value}<br><span class="dim">交易通知與營銷訂閱分開處理；你可隨時退出營銷訂閱。</span>`
    : `✓ Registered — thank you for your interest in the Rokid HK flagship.<br>Ref <b>${reg}</b> · Interests ${ints.length||'(none)'} · Confirmation will be sent to ${f.email.value}<br><span class="dim">Transactional and marketing messages are handled separately; unsubscribe anytime.</span>`);
  el.classList.add('show');
  el.scrollIntoView({behavior:'smooth', block:'center'});
});

/* ============ data-interest shortcut (hero demo button) ============ */
document.querySelectorAll('[data-interest]').forEach(a=>{
  a.addEventListener('click', ()=>{
    const box = document.querySelector(`input[name="int"][value="${a.dataset.interest}"]`);
    if (box) box.checked = true;
  });
});

/* ============ hero canvas: harbour night HUD ============ */
(function(){
  const cv = document.getElementById('sky');
  const ctx = cv.getContext('2d');
  let W, H, dpr, buildings = [], windows = [], stars = [], t0 = performance.now();
  // deterministic RNG
  function mulberry32(a){return function(){a|=0;a=a+0x6D2B79F5|0;let t=Math.imul(a^a>>>15,1|a);t=t+Math.imul(t^t>>>7,61|t)^t;return((t^t>>>14)>>>0)/4294967296}}
  const rnd = mulberry32(20260930);
  function build(){
    dpr = Math.min(2, window.devicePixelRatio||1);
    W = cv.clientWidth; H = cv.clientHeight;
    cv.width = W*dpr; cv.height = H*dpr; ctx.setTransform(dpr,0,0,dpr,0,0);
    buildings = []; windows = []; stars = [];
    const horizon = H*0.62;
    for (let i=0;i<90;i++) stars.push({x:rnd()*W, y:rnd()*horizon*0.7, r:rnd()*1.1+0.2, p:rnd()*6.28});
    // two layers of skyline
    const layers = [
      {yBase:horizon, hMin:H*0.10, hMax:H*0.30, col:'#0b1420', wMin:24, wMax:70, lit:0.10},
      {yBase:horizon+H*0.02, hMin:H*0.06, hMax:H*0.22, col:'#060a10', wMin:30, wMax:90, lit:0.16},
    ];
    layers.forEach((L,li)=>{
      let x = -20;
      while (x < W+40){
        const w = L.wMin + rnd()*(L.wMax-L.wMin);
        const h = L.hMin + rnd()*(L.hMax-L.hMin);
        buildings.push({x, w, h, y:L.yBase-h, col:L.col, layer:li, antenna: rnd()>0.82 ? h*0.25 : 0});
        // windows on near layer
        const cols = Math.floor(w/9), rows = Math.floor(h/14);
        for(let cx=0; cx<cols; cx++) for(let cy=0; cy<rows; cy++){
          if (rnd() < L.lit){
            const kind = rnd();
            windows.push({
              x: x+3+cx*9, y: L.yBase-h+4+cy*14,
              c: kind<0.72 ? '#ffd9a0' : (kind<0.9 ? '#9adfff' : '#00ffa3'),
              p: rnd()*6.28, sp: 0.2+rnd()*0.8, a: 0.25+rnd()*0.55
            });
          }
        }
        x += w + 2 + rnd()*10;
      }
    });
  }
  function frame(now){
    const t = (now - t0)/1000;
    const horizon = H*0.62;
    // sky
    const g = ctx.createLinearGradient(0,0,0,horizon);
    g.addColorStop(0,'#04060b'); g.addColorStop(0.75,'#071019'); g.addColorStop(1,'#0a1a26');
    ctx.fillStyle = g; ctx.fillRect(0,0,W,horizon);
    // stars
    stars.forEach(s=>{
      ctx.globalAlpha = 0.25 + 0.2*Math.sin(t*0.6+s.p);
      ctx.fillStyle = '#cfe6ff'; ctx.fillRect(s.x, s.y, s.r, s.r);
    });
    ctx.globalAlpha = 1;
    // buildings
    buildings.forEach(b=>{
      ctx.fillStyle = b.col; ctx.fillRect(b.x, b.y, b.w, b.h + H*0.03);
      if (b.antenna){ ctx.fillRect(b.x + b.w*0.5 - 0.5, b.y - b.antenna, 1, b.antenna); }
    });
    // windows (flicker)
    windows.forEach(w=>{
      const a = w.a * (0.6 + 0.4*Math.sin(t*w.sp + w.p));
      ctx.globalAlpha = Math.max(0.05, a);
      ctx.fillStyle = w.c; ctx.fillRect(w.x, w.y, 2.2, 3.2);
    });
    ctx.globalAlpha = 1;
    // water
    const wg = ctx.createLinearGradient(0,horizon,0,H);
    wg.addColorStop(0,'#081521'); wg.addColorStop(1,'#03060a');
    ctx.fillStyle = wg; ctx.fillRect(0,horizon,W,H-horizon);
    // reflections: jittered streaks under lit buildings
    ctx.globalAlpha = 0.10;
    windows.forEach((w,i)=>{
      if (i%3!==0) return;
      const jx = Math.sin(t*1.4 + w.p)*3;
      ctx.fillStyle = w.c;
      ctx.fillRect(w.x + jx, horizon + 4 + (i%40)*3, 2, 10 + 8*Math.sin(t + w.p));
    });
    ctx.globalAlpha = 1;
    // scanline sweep
    const sy = ((t % 9)/9) * (horizon + 40);
    const sg = ctx.createLinearGradient(0, sy-36, 0, sy+2);
    sg.addColorStop(0,'rgba(0,255,163,0)'); sg.addColorStop(1,'rgba(0,255,163,0.16)');
    ctx.fillStyle = sg; ctx.fillRect(0, sy-36, W, 38);
    ctx.fillStyle = 'rgba(0,255,163,0.55)'; ctx.fillRect(0, sy, W, 1);
    // drifting mist band
    ctx.globalAlpha = 0.05;
    ctx.fillStyle = '#9adfff';
    const mx = ((t*12) % (W+600)) - 300;
    ctx.fillRect(mx, horizon-60, 260, 2);
    ctx.fillRect((mx*1.7)%(W+400)-200, horizon-120, 180, 1.5);
    ctx.globalAlpha = 1;
    requestAnimationFrame(frame);
  }
  build();
  window.addEventListener('resize', build);
  requestAnimationFrame(frame);
})();

/* ============ benefits spotlight ============ */
(function(){
  const bs = [...document.querySelectorAll('.benefit')];
  if (!bs.length) return;
  let i = 0, timer = null;
  function lit(n){
    bs.forEach((b, j) => {
      b.classList.toggle('lit', j === n);
      const bm = b.querySelector('.beam');
      if (bm){ bm.style.transition = 'none'; bm.style.width = '0'; }
    });
    const bm = bs[n].querySelector('.beam');
    if (bm){ void bm.offsetWidth; bm.style.transition = 'width 2.6s linear'; bm.style.width = '100%'; }
  }
  function start(){ timer = setInterval(() => { i = (i + 1) % bs.length; lit(i); }, 2600); }
  function stop(){ clearInterval(timer); timer = null; }
  lit(0); start();
  const wrap = document.querySelector('.benefits');
  wrap.addEventListener('mouseenter', stop);
  wrap.addEventListener('mouseleave', () => { if (!timer){ i = (i + 1) % bs.length; lit(i); start(); } });
})();

/* ============ media slots & hero KV detection ============ */
document.querySelectorAll('.media').forEach(box => {
  box.querySelectorAll('.media-asset').forEach(asset => {
    const ok = () => box.classList.add('has-asset');
    if (asset.tagName === 'IMG'){
      if (asset.complete && asset.naturalWidth > 0) ok();
      else asset.addEventListener('load', ok);
    } else if (asset.tagName === 'VIDEO'){
      asset.addEventListener('loadeddata', ok);
    }
  });
});
const mvio = new IntersectionObserver(entries => {
  entries.forEach(e => { e.isIntersecting ? e.target.play().catch(()=>{}) : e.target.pause(); });
}, {threshold:.25});
document.querySelectorAll('video.media-asset').forEach(v => mvio.observe(v));
(function(){
  const hero = document.querySelector('.hero');
  if (!hero) return;
  const kv = hero.querySelector('.hero-kv-asset');
  if (kv && kv.tagName === 'VIDEO') kv.addEventListener('loadeddata', () => hero.classList.add('has-kv'));
  const kvs = hero.querySelector('.hero-kv-still');
  if (kvs){
    const ok = () => hero.classList.add('has-kv');
    if (kvs.complete && kvs.naturalWidth > 0) ok();
    else kvs.addEventListener('load', ok);
  }
})();

/* ============ verb tabs (rail + arrows) ============ */
(function(){
  const tabs = [...document.querySelectorAll('.vtab')];
  const panels = [...document.querySelectorAll('.vpanel')];
  if (!tabs.length || !panels.length) return;
  const nav = document.createElement('div');
  nav.className = 'vt-nav';
  nav.innerHTML = '<button type="button" data-d="-1" aria-label="上一個">‹</button><button type="button" data-d="1" aria-label="下一個">›</button>';
  let cur = 0;
  function show(i){
    cur = (i + tabs.length) % tabs.length;
    tabs.forEach((t, j) => t.classList.toggle('on', j === cur));
    panels.forEach((p, j) => p.classList.toggle('on', j === cur));
    panels[cur].querySelector('.vtab-media').appendChild(nav);
  }
  tabs.forEach((t, j) => t.addEventListener('click', () => show(j)));
  nav.addEventListener('click', e => {
    const b = e.target.closest('button');
    if (b) show(cur + Number(b.dataset.d));
  });
  show(0);
})();

/* ============ scroll reveal + media parallax ============ */
(function(){
  const sel = '.sec-label,.tl-cell,.founder-head,.founder-media,.first-grid>*,.vexp-row,.prod-row,.program-head,.day-detail,.guests-head,.guest-card,.store-grid>div,.reg-grid>div,.faq-list,.stations';
  const els = [...document.querySelectorAll(sel)];
  els.forEach(el => el.classList.add('rv'));
  const io = new IntersectionObserver(entries => {
    entries.forEach(e => { if (e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
  }, {threshold:.1});
  els.forEach(el => io.observe(el));

  /* scroll-linked parallax on media imagery */
  const boxes = [...document.querySelectorAll('.media:not(.fit)')];
  if (!boxes.length) return;
  let queued = false;
  function upd(){
    queued = false;
    const vh = innerHeight;
    boxes.forEach(box => {
      const r = box.getBoundingClientRect();
      if (r.bottom < -80 || r.top > vh + 80) return;
      const p = (r.top + r.height / 2 - vh / 2) / vh;
      box.querySelectorAll('.media-asset').forEach(im => {
        im.style.setProperty('--py', (p * -12).toFixed(1) + 'px');
      });
    });
  }
  addEventListener('scroll', () => { if (!queued){ queued = true; requestAnimationFrame(upd); } }, {passive:true});
  upd();
})();

/* ============ phase gates (auto reveal by date) ============ */
(function(){
  const now = Date.now();
  document.querySelectorAll('[data-phase]').forEach(el => {
    const p = el.dataset.phase;
    const show = (p === 'presale' && now >= +PRESALE_AT) || (p === 'open' && now >= +OPEN_AT);
    el.hidden = !show;
  });
})();

/* ============ douban-style chrome: progress + chapter nav ============ */
(function(){
  const sprog = document.getElementById('sprog');
  if (sprog){
    const onScroll = () => {
      const h = document.documentElement;
      const max = h.scrollHeight - h.clientHeight;
      sprog.style.width = (max > 0 ? (h.scrollTop / max * 100) : 0).toFixed(2) + '%';
    };
    addEventListener('scroll', () => requestAnimationFrame(onScroll), {passive:true});
    onScroll();
  }
  const chap = document.getElementById('chap');
  const secs = [...document.querySelectorAll('section[id]')].filter(s => !s.hidden);
  if (chap && secs.length){
    secs.forEach((s, i) => {
      const a = document.createElement('a');
      a.href = '#' + s.id;
      const b = s.querySelector('.sec-label b');
      const label = b ? b.textContent : (s.classList.contains('hero') ? 'KV' : String(i + 1).padStart(2, '0'));
      a.innerHTML = `<span>${label}</span><i></i>`;
      chap.appendChild(a);
    });
    const links = [...chap.children];
    const io = new IntersectionObserver(es => {
      es.forEach(e => {
        if (e.isIntersecting){
          const idx = secs.indexOf(e.target);
          links.forEach((l, j) => l.classList.toggle('on', j === idx));
        }
      });
    }, {threshold:.3});
    secs.forEach(s => io.observe(s));
  }
})();

/* ============ mobile asset variants (-m files auto-detected ≤700px) ============ */
if (window.matchMedia('(max-width:700px)').matches){
  document.querySelectorAll('.media img.media-asset, .hero-kv-still, .hook-bg img').forEach(img => {
    const src = img.getAttribute('src');
    if (!src) return;
    const m = src.replace(/(\.[a-z0-9]+)$/i, '-m$1');
    if (m === src) return;
    const probe = new Image();
    probe.onload = () => { img.src = m; };
    probe.src = m;
  });
}

/* ============ init language ============ */
setLang((document.documentElement.lang || '').toLowerCase().indexOf('zh') === 0 ? 'zh' : 'en');



/* reserve theme header space: KV stays fixed height, text clears overlay nav */
(function(){
  var done = false;
  var setHdr = function(){
    if (done) return;
    var hg = document.getElementById('header-group');
    if (!hg) { done = true; return; }
    if (window.scrollY > 50) return;
    var hero = document.querySelector('.p-hero') || document.querySelector('.hero');
    if (!hero) { done = true; return; }
    var top = hero.getBoundingClientRect().top;
    if (top < 0) top = 0;
    document.documentElement.style.setProperty('--rokid-hdr', top.toFixed(0) + 'px');
    var pad = 0;
    hg.querySelectorAll('#header-component, .header, .header-section, [class*="announce"], :scope > *').forEach(function(el){
      var r = el.getBoundingClientRect();
      if (r.height > 0 && r.height < 300){
        var over = r.bottom - top;
        if (over > pad && over < 300) pad = over;
      }
    });
    document.documentElement.style.setProperty('--rokid-hdr-pad', pad.toFixed(0) + 'px');
    done = true;
  };
  addEventListener('load', setHdr);
  setTimeout(setHdr, 600);
  setTimeout(setHdr, 1600);
  addEventListener('resize', function(){ done = false; setHdr(); });
  setHdr();
})();

/* ============ Shopify theme editor: scoped re-init（不整页刷新） ============
   编辑器局部重渲染某 section 后，仅对该 section 重新绑定显影/交互逻辑。
   线上访问不执行；每个元素以 data-*Bound 去重，绝不重复绑定。 */
function rokidRebind(scope){
  if (!scope || !scope.querySelectorAll) scope = document;
  scope.querySelectorAll('.media').forEach(box => {
    box.querySelectorAll('.media-asset').forEach(asset => {
      const ok = () => box.classList.add('has-asset');
      if (asset.tagName === 'IMG'){
        if (asset.complete && asset.naturalWidth > 0) ok();
        else asset.addEventListener('load', ok);
      } else if (asset.tagName === 'VIDEO'){
        if (asset.readyState >= 2) ok();
        else asset.addEventListener('loadeddata', ok);
      }
    });
  });
  scope.querySelectorAll('.logo-slot').forEach(box => {
    const asset = box.querySelector('.ls-asset');
    if (!asset) return;
    const ok = () => box.classList.add('has-asset');
    if (asset.complete && asset.naturalWidth > 0) ok();
    else asset.addEventListener('load', ok);
  });
  const io = new IntersectionObserver(es => {
    es.forEach(e => { if (e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
  }, {threshold:.12});
  scope.querySelectorAll('.rv').forEach(el => io.observe(el));
  if (window.matchMedia('(max-width:700px)').matches){
    scope.querySelectorAll('.media img.media-asset, .hook-bg img, .kv-layers img, .hero-kv-still').forEach(img => {
      const src = img.getAttribute('src');
      if (!src) return;
      const m = src.replace(/(\.[a-z0-9]+)$/i, '-m$1');
      if (m === src) return;
      const probe = new Image();
      probe.onload = () => { img.src = m; };
      probe.src = m;
    });
  }
  if (typeof setLang === 'function') setLang(document.documentElement.dataset.lang || 'zh');
}
if (window.Shopify && Shopify.designMode){
  document.addEventListener('shopify:section:load', e => {
    rokidRebind(e.target);
    if (typeof rokidRebindExtra === 'function') rokidRebindExtra(e.target);
  });
}

/* ---- campaign 专属：KV 显影 + verbs/vtab/节目/表单 ---- */
function rokidRebindExtra(scope){
  const hero = scope.matches && scope.matches('.hero') ? scope : scope.querySelector('.hero');
  if (hero && !hero.dataset.heroBound){
    hero.dataset.heroBound = '1';
    const kv = hero.querySelector('.hero-kv-asset');
    if (kv && kv.tagName === 'VIDEO'){
      if (kv.readyState >= 2) hero.classList.add('has-kv');
      else kv.addEventListener('loadeddata', () => hero.classList.add('has-kv'));
    }
    const kvs = hero.querySelector('.hero-kv-still');
    if (kvs){
      const ok = () => hero.classList.add('has-kv');
      if (kvs.complete && kvs.naturalWidth > 0) ok();
      else kvs.addEventListener('load', ok);
    }
  }
  scope.querySelectorAll('.verb').forEach(v => {
    if (v.dataset.verbBound) return;
    v.dataset.verbBound = '1';
    const row = v.querySelector('.verb-row');
    if (!row) return;
    row.addEventListener('click', () => {
      const open = v.classList.contains('open');
      document.querySelectorAll('.verb.open').forEach(o => o.classList.remove('open'));
      if (!open) v.classList.add('open');
    });
  });
  const strip = scope.querySelector('#dayStrip') || document.getElementById('dayStrip');
  if (strip && !strip.dataset.dayBound){
    strip.dataset.dayBound = '1';
    strip.querySelectorAll('button').forEach((b, i) => {
      b.addEventListener('click', () => { currentDay = i; renderDay(i); });
    });
  }
  const tabs = scope.querySelectorAll('.vtab-tab');
  if (tabs.length){
    const panels = scope.querySelectorAll('.vtab-panel');
    tabs.forEach((t, j) => {
      if (t.dataset.vtBound) return;
      t.dataset.vtBound = '1';
      t.addEventListener('click', () => {
        tabs.forEach((x, k) => x.classList.toggle('on', k === j));
        panels.forEach((p, k) => p.classList.toggle('on', k === j));
      });
    });
  }
  const form = scope.querySelector('#regForm') || document.getElementById('regForm');
  if (form && !form.dataset.regBound){
    form.dataset.regBound = '1';
    form.addEventListener('submit', e => {
      e.preventDefault();
      const f = e.target;
      if (!f.name.value.trim() || !f.email.value.includes('@') || !/^[0-9]{8,11}$/.test(f.phone.value.trim())){
        f.reportValidity && f.reportValidity();
        return;
      }
      const zh = document.documentElement.dataset.lang === 'zh';
      const reg = 'HK-' + Math.random().toString(36).slice(2,6).toUpperCase() + '-' + String(Math.floor(Math.random()*900)+100);
      const ints = [...f.querySelectorAll('input[name="int"]:checked')].map(c=>c.value);
      const el = document.getElementById('regSuccess');
      if (el){
        el.innerHTML = (zh
          ? `✓ 登記成功 — 多謝你對 Rokid 香港旗艦店的關注。<br>登記編號 <b>${reg}</b> · 已選項目 ${ints.length||'（未選）'} · 確認通知將發至 ${f.email.value}<br><span class="dim">交易通知與營銷訂閱分開處理；你可隨時退出營銷訂閱。</span>`
          : `✓ Registered — thank you for your interest in the Rokid HK flagship.<br>Ref <b>${reg}</b> · Interests ${ints.length||'(none)'} · Confirmation will be sent to ${f.email.value}<br><span class="dim">Transactional and marketing messages are handled separately; unsubscribe anytime.</span>`);
        el.classList.add('show');
        el.scrollIntoView({behavior:'smooth', block:'center'});
      }
    });
  }
  const langSel = document.getElementById('langSel');
  const langBtn = document.getElementById('langBtn');
  if (langSel && langBtn && !langSel.dataset.langBound){
    langSel.dataset.langBound = '1';
    langBtn.addEventListener('click', e => {
      e.stopPropagation();
      const open = langSel.classList.toggle('open');
      langBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    langSel.querySelectorAll('.lang-menu button').forEach(b => b.addEventListener('click', e => {
      e.stopPropagation();
      setLang(b.dataset.lang);
      langSel.classList.remove('open');
      langBtn.setAttribute('aria-expanded', 'false');
    }));
    document.addEventListener('click', () => { langSel.classList.remove('open'); langBtn.setAttribute('aria-expanded', 'false'); });
  }
}
